export enum SupplierOrderStatusTypes {
    PENDING_ORDER = 1,
    PENDING_DELIVERY = 2,
    DELIVERED = 3,
    CANCELLED = 4
}
